import styled from "styled-components";

interface StyledIconComponentProps {
  $size: number;
  $stroke: string;
  $fill: string;
  $strokeWidth: number;
  $rotate: number;
  $hoverBackground: string;
  $hoverStroke: string;
  $activeBackground: string;
  $activeStroke: string;
  $borderRadius: string;
}

export const StyledIconComponent = styled.div<StyledIconComponentProps>`
  display: flex;
  width: max-content;
  height: max-content;
  background-color: transparent;
  border-radius: ${({ $borderRadius }) => $borderRadius};

  & > svg {
    width: ${(props) => `${props.$size}px`};
    height: ${(props) => `${props.$size}px`};
    transition: transform 0.3s ease;
    transform: ${(props) =>
      props.$rotate ? `rotate(${props.$rotate}deg)` : ""};
    path {
      stroke: ${(props) => `var(${props.$stroke})`};
      fill: ${(props) => props.$fill !== "NULL" && `var(${props.$fill})`};
      stroke-width: ${(props) => props.$strokeWidth};
    }
  }

  &:hover {
    background-color: ${({ $hoverBackground }) => `var(${$hoverBackground})`};
    & > svg path {
      stroke: ${({ $hoverStroke }) => `var(${$hoverStroke})`};
    }
  }

  &:active {
    background-color: ${({ $activeBackground }) => `var(${$activeBackground})`};
    & > svg path {
      stroke: ${({ $activeStroke }) => `var(${$activeStroke})`};
    }
  }
`;
